import type { ProductForCustomer } from "../Product.js";
import type { ProductOption } from "../ProductOption.js";
import { ProductSize } from "../ProductSize.js";
import { productSizeKeyMap } from "../productSizeKeyMap.js";
import { restrictedProductOptions } from "../restrictedProductOptions.js";

export function isProductForCustomerConfigurable(
	{ enabledOptions }: Pick<ProductForCustomer, "enabledOptions">,
	includeRestrictedOptions: boolean,
): boolean {
	return Object.values(ProductSize).some((size: ProductSize) =>
		enabledOptions[productSizeKeyMap[size]].some((enabledOption: ProductOption) => {
			if (!includeRestrictedOptions && restrictedProductOptions.includes(enabledOption)) {
				return false;
			}
			return true;
		}),
	);
}
